/**
 * Merge WhatsApp template categories into a single global value.
 * MARKETING is sticky: if the existing state or any incoming category
 * is MARKETING, the result stays MARKETING (never downgraded to UTILITY).
 */
export function resolveWhatsappTemplateCategory(
  ...categories: Array<string | null | undefined>
): string | null {
  const normalized = categories.filter(Boolean) as string[];
  if (normalized.length === 0) {
    return null;
  }
  if (normalized.some((category) => category.toUpperCase() === 'MARKETING')) {
    return 'MARKETING';
  }
  return normalized[normalized.length - 1];
}
